import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		authState: {
			token: localStorage.getItem("token-admin") || "",
			loggedUser: JSON.parse(localStorage.getItem("logged-admin")) || "",
			status: "notlogged"
		},
		cart: JSON.parse(localStorage.getItem("cart")) || {},
		cartAdded: false
	},
	getters: {
		isAuthenticated: (state) => !!state.authState.token,
		authStatus: (state) => state.authState.status,
		loggedUser: (state) => state.authState.loggedUser,
		cart: (state) => state.cart,
		cartAdded: (state) => state.cartAdded
	},
	mutations: {
		saveCart(state, cart) {
			localStorage.setItem("cart", JSON.stringify(cart))
			state.cart = cart
		},
		deleteCart(state) {
			localStorage.removeItem("cart")
			state.cart = null
		},
		authSuccess(state, { token, loggedUser }) {
			state.authState.status = "logged"
			state.authState.token = token
			state.authState.loggedUser = loggedUser
			localStorage.setItem("logged-admin", JSON.stringify(loggedUser))
		},
		logout(state) {
			state.authState.token = ""
			state.authState.loggedUser = {}
			state.authState.status = "notlogged"
			localStorage.removeItem("logged-admin")
		},
		setCatdAdded(state, cartAdded) {
			state.cartAdded = cartAdded
		}

	}
})
